<template>
  <div class="component gw-list-component">
    <div class="header-gateway-list">
      <div class="no">No</div>
      <div class="gateway_id">Gateway ID</div>
      <div class="email">Email Address</div>
      <div class="action_group">&nbsp;</div>
    </div>
    <template v-if="lst_gateways_filtering.length > 0">
      <GatewayRowItem v-for="(gateway, index) in lst_gateways_filtering" :key="index" :no="index+1" :gateway="gateway" />
    </template>
    <template v-else>
      <p>No Gateways.</p>
    </template>
  </div>
</template>

<script>
import service from "@/net/index.js";
import GatewayRowItem from "@/components/GatewayItem.vue";
export default {
  name: "GatewayList",
  data() {
    return {
      lst_gateways: [],
      lst_gateways_filtering: []
    }
  },
  props: {
    searchQuery: {
      type: String,
      required: true
    }
  },
  components: {
    GatewayRowItem
  },
  computed: {
    refresh() {
      return this.$store.state.refreshEvent;
    }
  },
  mounted() {
    this.$store.state.isLoading = true;
    this.init();
  },
  methods: {
    init() {
      service.getGateways().then(res => {
        if (res.status === 200) {
          this.lst_gateways = res.data.result;
          this.lst_gateways.sort(function(gatewayA, gatewayB) {
            if (gatewayA.email < gatewayB) {
              return -1;
            }
          });
          this.filtering();
        }
      });
    },
    filtering() {
      const self = this;
      console.log(self.searchQuery);
      this.lst_gateways_filtering = this.lst_gateways.filter(gateway => {
        let query = self.searchQuery ? self.searchQuery.toLowerCase() : "";
        let email = gateway.email;
        let gateway_id = gateway.gatewayId;
        return email.includes(query) || gateway_id.includes(query);
      });
      console.log(this.lst_gateways_filtering);

      this.$store.state.isLoading = false;
    }
  },
  watch: {
    refresh: function() {
      this.init();
    },
    searchQuery: function() {
      this.filtering();
    }
  }
}
</script>

<style lang="scss">
  .header-gateway-list {
    display: flex;
    align-items: center;
    border-bottom: 1px solid #E5E5E5;
    background: #E5E5E5;
    padding: 10px 0px;
    font-weight: bold;
    .no {
      width: 100px;
      min-width: 100px;
    }
    .email {
      width: 100%;
      text-align: left;
      padding: 0px 10px
    }
    .gateway_id {
      padding: 0px 10px;
      width: 200px;
      min-width: 200px;
      text-align: left;
    }
    .action_group {
      width: 130px;
      min-width: 130px;
    }
  }
</style>